import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';
import { ValidateStatus } from 'antd/lib/form/FormItem';
import dynamic from 'next/dynamic';
import { FC } from 'react';
import { useIntl } from 'react-intl';
import { MIN_PASSWORD_LENGTH } from '../../constants/configuration';
const PasswordChecklist = dynamic(() => import('react-password-checklist'), {
  ssr: false,
});

interface AveliosPasswordValidationProps {
  password1: string;
  password2: string;
  onChange: (status: ValidateStatus) => void;
}

export const AveliosPasswordValidation: FC<AveliosPasswordValidationProps> = ({
  password2,
  password1,
  onChange,
}) => {
  const { formatMessage } = useIntl();
  return (
    <div style={{ textAlign: 'left' }}>
      <PasswordChecklist
        rules={['minLength', 'specialChar', 'number', 'capital', 'match']}
        minLength={MIN_PASSWORD_LENGTH}
        messages={{
          minLength: formatMessage(
            { id: 'password-validation.minLength' },
            { length: MIN_PASSWORD_LENGTH },
          ),
          number: formatMessage({ id: 'password-validation.number' }),
          match: formatMessage({ id: 'password-validation.match' }),
          capital: formatMessage({ id: 'password-validation.capital' }),
          specialChar: formatMessage({ id: 'password-validation.specialChar' }),
        }}
        iconSize={8}
        iconComponents={{
          InvalidIcon: (
            <CloseCircleOutlined style={{ color: '#FF0033', maxWidth: 36, marginTop: 3.5 }} />
          ),
          ValidIcon: (
            <CheckCircleOutlined style={{ color: '#4BCA81', maxWidth: 36, marginTop: 3.5 }} />
          ),
        }}
        value={password1}
        valueAgain={password2}
        onChange={(isValid) => {
          onChange(!isValid ? 'error' : 'success');
        }}
      />
    </div>
  );
};
